export default __webpack_public_path__ + "static/media/19.8002f059.jpg";